import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useApi } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const AuthedImage = ({ fileId, className, onDelete, caption, testId }) => {
  const api = useApi();
  const [src, setSrc] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let url;
    let cancelled = false;
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => {
      if (cancelled) return;
      url = URL.createObjectURL(r.data);
      setSrc(url);
    }).catch(() => {});
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [api, fileId]);

  return (
    <div className={`relative group ${className}`} data-testid={testId}>
      <button type="button" onClick={() => setOpen(true)} className="w-full h-full rounded-md overflow-hidden bg-[#0B0C10] border border-[#2A2E39] block" data-testid={`${testId}-open`}>
        {src ? <img src={src} alt="Foto" className="w-full h-full object-cover" /> : <div className="w-full h-full shimmer" />}
      </button>
      {onDelete && (
        <button type="button" onClick={onDelete} data-testid={`${testId}-delete`} className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#FF3838] text-white grid place-items-center shadow-lg hover:bg-red-500 transition-colors">
          <X className="w-4 h-4" />
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0C10] border-[#2A2E39] max-w-3xl p-2">
          <DialogTitle className="sr-only">Foto</DialogTitle>
          {src && <img src={src} alt="Foto ampliada" className="w-full max-h-[80vh] object-contain rounded" data-testid={`${testId}-full`} />}
          {caption && <p className="text-xs text-slate-400 px-2 pb-1">{caption}</p>}
        </DialogContent>
      </Dialog>
    </div>
  );
};
